module.exports = __webpack_public_path__ + "img/tsumugiTwitterLink.210f3997.png";